/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {SpineSymbol} from "./SpineSymbol";
import {DasUBootGameMode} from "../../server/DasUBootGameMode";
import {DasUBootRoundType} from "../../server/DasUBootData";

export function isScatterSymbol(value:any):value is ScatterSymbol {
    return value.symbolName === "S";
}


export class ScatterSymbol extends SpineSymbol {

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName, DasUBootGameAssets.SCATTER_SYMBOL_SPINE);
    }

    destroy(options?:{children?:boolean; texture?:boolean; baseTexture?:boolean}) {
        if (this._stateAnimation) {
            this._stateAnimation.kill();
        }
        super.destroy(options);
    }


    private getIdleAnimationName() {
        if ((DasUBoot.model.data.roundType == DasUBootRoundType.FREE_SPIN || DasUBoot.model.data.roundType == DasUBootRoundType.SUPER_FREE_SPIN) && DasUBoot.model.data.nextMode != DasUBootGameMode.NORMAL) {
            return "plus2";
        }

        let count = DasUBoot.model.clientData.scatterCountAtReel[this.reel.reelId];
        count = Math.max(Math.min(count, 4), 1);
        return "idle" + count;
    }

    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();

        switch (state) {
            case DasUBootSymbolStates.COLLAPSE:
            case DasUBootSymbolStates.NORMAL:
                if (!this.isVisibleInReel()) {
                    return super.getStateAnimation(DasUBootSymbolStates.NORMAL);
                }
                tl.add(() => this.setState(state));
                tl.add(() => this.moveToNormalLayer());
                tl.add(this.getSpineAnimation(this.getIdleAnimationName(), 0, true, -1));
                break;
            case DasUBootSymbolStates.LANDING:
                if (!this.isVisibleInReel()) {
                    return this.getStateAnimation(DasUBootSymbolStates.NORMAL);
                }
                tl.add(() => this.setState(state));
                tl.add(() => this.moveToWinLayer());

                tl.add(() => DasUBoot.soundPlayer.playScatterLanding(DasUBoot.model.clientData.scatterCountAtReel[this.reel.reelId]));
                tl.add(() => DasUBoot.reelView.reelFrame.startScatterAttention(DasUBoot.model.clientData.scatterCountAtReel[this.reel.reelId]));
                tl.add(() => {DasUBoot.reelView.getLandingShake(false).play(0)});

                tl.add([
                    this.getSpineAnimation(this.getIdleAnimationName(), 0, true, -1),
                    this.getSpineAnimation("landing", 1, true)
                ])
                break;
            case DasUBootSymbolStates.START_SPIN:
                tl = super.getStateAnimation(state);
                tl.add(this.getStateAnimation(DasUBootSymbolStates.NORMAL));
                break;
            case DasUBootSymbolStates.NO_WIN:
                tl = super.getStateAnimation(DasUBootSymbolStates.NORMAL);
                break;
            default:
                tl = super.getStateAnimation(state);
                tl.add(() => this.removeSpineFromView(), 0);

        }

        this._stateAnimation = tl;
        return tl;
    }
}